import React, { useState, useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
	inputRoot: {
		color: 'black'
	},
	inputFocused: {
		color: 'black'
	},
	inputLabel: {
		marginLeft: '0px',
		color: 'black'
	},
	selectMenu: {
		color: 'black',
		height: '1.26em'
	},
	selectIcon: {
		fontSize: '24px'
	}
})

export default ({
	label,
	initialValue,
	digitsAllowed,
	onChangeCallback,
	allowDecimal,
	data,
	type,
	maxLength,
	min,
	max,
	pattern,
	placeholder,
	input,
	meta: { touched, invalid, error },
	...custom
}) => {
	var classes = useStyles()
	const [value, setValue] = useState()
	const [oldValue, setOldValue] = useState()
	const [errorText, setErrorText] = useState(null)
	const [validationTimeoutId, setValidationTimeoutId] = useState(null)

	useEffect(
		() => {
			clearTimeout(validationTimeoutId)
			if(touched
				&& error){
					let timeout = setTimeout(() => setErrorText(error), 200)
					setValidationTimeoutId(timeout)
				}
			else {
				setValidationTimeoutId(null)
				setErrorText(null)
			}
		},
		[touched, error]
	)

	// const onChange = (e) => {
	// console.log(e.target.value)
	// 	let reg = new RegExp(pattern, 'g')
	// 	var value = e.target.value
	// 	var isValid = reg.test(value)
	// 	// console.log(e.target.value)
	// 	console.log('das')
	// 	if (isValid) {
	// 		console.log('isVaid')
	// 		setValue(e.target.value)
	// 		onChangeCallback && onChangeCallback(e.target.value)
	// 	}
	// }

	// useEffect(() => {
	//   setValue(initialValue)
	// }, [initialValue])

	const onKeyPress = (evt) => {
		var charCode = evt.which ? evt.which : evt.keyCode

		const selectionStart = evt.target.selectionStart ?? evt.target.value.length - 1

		const newValue =
			evt.target.value.slice(0, selectionStart) +
			String.fromCharCode(charCode) +
			evt.target.value.slice(selectionStart)

		var signCount = (newValue.match(/\-/g) || []).length

		if (charCode < 48 || charCode > 57) {
			if (allowDecimal && charCode === 46) {
				let temp = evt.target.value + String.fromCharCode(charCode)
				var count = (temp.match(/\./g) || []).length
				if (count <= 1) {
					return true
				}
			}
			if (signCount == 2) {
				evt.preventDefault()
				return false
			}
			if (evt.target.value.length === 1 && charCode === 45 && selectionStart === 0 && evt.target.selectionEnd === 0) {
				return true
			}
			if (charCode === 45 && signCount <= 1 && selectionStart === 0) {
				return true
			}
			evt.preventDefault()
			return false
		} else if (charCode === 46 && evt.target.value && evt.target.value.split('.').length > 1) {
			evt.preventDefault()
			return false
		} else if (selectionStart === 0 && signCount === 1 && charCode === 45) {
			evt.preventDefault()
			return false
		}
		if (evt.target.value.split('.').length == 2) {
			if (newValue.split('.')[0] == evt.target.value.split('.')[0]) {
				if (newValue.split('.')[1] != evt.target.value.split('.')[1]) {
					if (evt.target.value.split('.')[1].length >= digitsAllowed) {
						evt.preventDefault()
						return false
					}
				}
			}
		}
		return true
	}

	const onPasteText = (evt) => {
		evt.preventDefault()
		// let existingText = evt.target.value,
		//   selectStart = evt.target.selectionStart,
		//   selectEnd = evt.target.selectionEnd

		// evt.clipboardData.items[0].getAsString((str) => {
		//   let value = existingText.substring(0, selectStart) + str + existingText.substring(selectEnd, existingText.length)
		//   console.log(value)
		// })
	}

	return (
		<TextField
            data-testid="number-field"
            type={type}
			label={label}
			onKeyPress={onKeyPress}
			onPaste={onPasteText}
			error={touched && invalid}
			helperText={errorText}
			variant='filled'
			fullWidth
			shrink
			onWheel={event => event.target.blur()}
			value={value}
			placeholder={placeholder}
			// onChange={onChange}
			digitsAllowed={digitsAllowed}
			InputLabelProps={{
				classes: {
					root: classes.inputLabel,
					focused: classes.inputLabel
				}
			}}
			InputProps={{
				classes: {
					root: classes.inputRoot,
					focused: classes.focused,
					input: classes.focused
				}
			}}
			inputProps={{
				style: { color: 'black' },
				maxLength: maxLength,
				min: min,
				max: max,
				pattern: pattern
			}}
			FormHelperTextProps={{
				classes: { error: classes.error, contained: classes.error, root: classes.error },
				style: {
					backgroundColor: '',
					marginLeft: '0',
					marginTop: '0',
					paddingTop: '6px',
					padding: '8px 0',
					fontSize: '16px'
				}
			}}
			{...input}
			{...custom}
		/>
	)
}
